import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
var filterRet0 = Coa.filterResponse(function (res) {
  if (res.ret !== 0) {
    try {
      var _window$aegis;
      (_window$aegis = window.aegis) === null || _window$aegis === void 0 ? void 0 : _window$aegis.vWarn({
        tag: 'checkFollowStatus请求错误[filterRet0]',
        error: res
      });
    } catch (_) {}
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
export function checkFollowStatus() {
  return Coa(Coa.filterResponse(function (res) {
    // res = {"label_infos":{"10000034":true},"msg":"OK","ret":0}
    // 关注过公众号
    return res.label_infos && res.label_infos['10000034'];
  }), filterRet0).run('//vip.video.qq.com/fcgi-bin/comm_cgi?name=user_label&cmd=5637&labels=10000034&otype=json');
}